export const pricing = {
	lifetime: {
		fullPrice: 50,
		fullPriceCents: undefined,
		price: 45,
		priceCents: undefined,
		salePercentage: 10,
		purchaseId: 'lifetime_plugin_10'
	},
	monthly: {
		fullPrice: 3,
		fullPriceCents: undefined,
		price: 2,
		priceCents: 70,
		salePercentage: 10,
		purchaseId: 'subscription_plugin_10'
	}
};
